import { TEMPLATES } from "utils/constants";
import AdherentInfo from "../RadianceCosa/AdherentInfo";
import AdherentTelecoms from "../RadianceCosa/AdherentTelecoms";
import Loading from "../RadianceCosa/Components/Spin";
import ContactUs from "../RadianceCosa/ContactUs";
import SubscriptionContract from "../RadianceCosa/Contract";
import Default from "../RadianceCosa/Default";
import ElectronicSignature from "../RadianceCosa/ElectronicSignature";
import Justification from "../RadianceCosa/Justification";
import NoSubscription from "../RadianceCosa/NoSubscription";
import Payment from "../RadianceCosa/Payment";
import Products from "../RadianceCosa/Products";
import Subscription from "../RadianceCosa/Subscription";
import SubscriptionDone from "../RadianceCosa/SubscriptionDone";
import Needs from "../Radiance/Needs";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES.RADIANCE.PAYMENT]: Payment,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION]: Subscription,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION_CONTRACT]:
    SubscriptionContract,
  [TEMPLATES.B2C.THEMES.RADIANCE.NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES.RADIANCE.B2C_SUBSCRIPTION_DONE]: SubscriptionDone,
  [TEMPLATES.B2C.THEMES.RADIANCE.JUSTIFICATIONS]: Justification,
  [TEMPLATES.B2C.THEMES.RADIANCE.ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.B2C.THEMES.RADIANCE.ADHERENT_TELECOMS]: AdherentTelecoms,
  [TEMPLATES.B2C.THEMES.RADIANCE.PRODUCTS]: Products,
  [TEMPLATES.B2C.THEMES.RADIANCE.CONTACT_US]: ContactUs,
  [TEMPLATES.B2C.THEMES.RADIANCE.NO_SUBSCRIPTION]: NoSubscription,
  [TEMPLATES.B2C.THEMES.RADIANCE.E_SIGN]: ElectronicSignature,
  default: Default,
};
export default Templates;
